import React, {useCallback, useContext, useEffect, useRef, useState} from "react";
import {Button, Form, Space, Typography, Checkbox} from "@bezlimit/bezlimit-ui";
import {useTranslation} from "react-i18next";
import {observer} from "mobx-react";
import _ from "lodash";
import "./style.scss";
// core
import {InterceptorContext, ModalContext} from "../../../core/Contexts";
import {getFieldsErrorSize} from "../../../core/functions/form";
import {IReservationsTurboBookingRequest} from "../../../core/models/Reservations";
import {IPhonesFiltersRequest} from "../../../core/models/PhonesFilters";
// services
import ReservationsService from "../../../services/ReservationsService";
import PhoneService from "../../../services/PhoneService";
// hooks
import useFormHandler from "../../../core/hooks/useFormHandler";
import useOnCancel from "../../../core/hooks/useOnCancel";
// components
import PhoneField from "../../fields/phone";
import Error from "../../modal/error";
import Success from "../../modal/success";
import UserService from "../../../services/UserService";
import ButtonChatSupport from "../../blocks/delivery/buttonChatSupport";
import {isPhonePattern} from "../numberSearch";

export default React.memo(
    observer(function BookANumberTurboForm({phone, type, filters, Service}: IProps) {
        const context = useContext(InterceptorContext);
        const contextModal = useContext(ModalContext);
        const ref = useRef(null);
        const {t} = useTranslation();
        const [state, setState] = useState<string>("3 часа");
        const [isUnderstand, setIsUnderstand] = useState(false);
        const [form] = Form.useForm();
        const formInstance = useFormHandler(form);
        const onCancel = useOnCancel(formInstance);

        useEffect(() => {
            let name: string;

            switch (type) {
                case 4:
                    name = "1 день";
                    break;
                case 5:
                    name = "5 дней";
                    break;
                default:
                    name = "3 часа";
                    break;
            }

            setState(name);
        }, [type]);

        const onClickWhatsApp = () => {
            (
                window.open(`https://wa.me/7${UserService.personalManager.phone}`, "_blank") as any
            ).focus();
        };

        const onFinish = async (values: IReservationsTurboBookingRequest) => {
            try {
                const filter =
                localStorage.getItem("isFavorite") === "collection"
                    ? "collection"
                    : localStorage.getItem("isFavorite") === 'true'
                    ? "favorite"
                    : "professional";
                    
               
                await ReservationsService.postReservationTurbo({...values,  additional_data: JSON.stringify({
                    source: "store_web",
                    filter,
                }),});
                contextModal?.setChildren(
                    <Success
                        title={
                            <Typography as="span">
                                {t("Номер успешно")}
                                <br />
                                {t("забронирован")}
                            </Typography>
                        }
                        subtitle={
                            <Typography as="span">
                                {t("Номер забронирован на {days},", {days: state})}
                                <br />
                                {t("вы можете просмотреть его на странице")}
                                <br />
                                {t("“Мои брони”")}
                            </Typography>
                        }
                    />
                );
                document
                    .getElementsByClassName("ant-modal-close-x")[0]
                    .addEventListener("click", () => {
                        isPhonePattern.argModalClose = isPhonePattern.argModalClose + 1;
                    });
            } catch (e: any) {
                if (_.isEqual(e.response.status, 430)) {
                    contextModal?.setChildren(
                        <Error
                            title="Вы превысили лимит"
                            message={
                                <Space size={16} direction="vertical">
                                    {_.isEqual(UserService.level.level, 0) ? (
                                        <>
                                            <Typography as="div" size={14} color="#000000">
                                                {t("Повторите попытку завтра.")}
                                                <br />
                                                {t("Чтобы увеличить лимит обратитесь в чат")}
                                            </Typography>
                                            <ButtonChatSupport
                                                type="primary"
                                                text="Написать в чат"
                                            />
                                        </>
                                    ) : (
                                        <>
                                            <Typography as="div" size={14} color="#000000">
                                                {t(
                                                    "Повторите попытку завтра. Чтобы увеличить лимит"
                                                )}
                                                <br />
                                                {t("обратитесь к персональному менеджеру")}
                                            </Typography>
                                            <Button onClick={onClickWhatsApp} type="primary">
                                                {t("Написать в WhatsApp")}
                                            </Button>
                                        </>
                                    )}
                                </Space>
                            }
                        />
                    );
                } else {
                    contextModal?.setChildren(<Error />);
                }
            }
        };

        const booked = useCallback(async (phone: number) => {
            const storage = localStorage.getItem("understand");

            if (storage) {
                const phones = JSON.parse(storage);
                const res = _.chain(phones)
                    .find((i) => _.isEqual(i, phone))
                    .valueOf();

                if (res) {
                    setIsUnderstand(res);
                }
            }
        }, []);

        useEffect(() => {
            booked(phone);
        }, [phone]);

        return (
            <div ref={ref}>
                <Typography as="div" className="bl-book-a-number-turbo-form">
                    <Form
                        form={formInstance}
                        layout="horizontal"
                        name="book-a-number-turbo"
                        onFinish={onFinish}
                        autoComplete="off"
                        initialValues={{
                            phone,
                            understand: false
                        }}
                    >
                        <Space size={24} direction="vertical">
                            <PhoneField noStyle hidden={true} />
                            {!isUnderstand && (
                                <Form.Item noStyle name="understand" valuePropName="checked">
                                    <Checkbox>
                                        <Typography color="#000">
                                            {t("Мне все понятно, не показывать в дальнейшем ")}
                                        </Typography>
                                    </Checkbox>
                                </Form.Item>
                            )}
                            <Form.Item noStyle shouldUpdate>
                                {({getFieldsValue, getFieldsError}) => {
                                    const {phone} = getFieldsValue();
                                    const errors = getFieldsErrorSize(getFieldsError);
                                    const formIsComplete = !!phone && !errors;

                                    return (
                                        <Button
                                            type={!formIsComplete ? "default" : "primary"}
                                            htmlType="submit"
                                            disabled={!formIsComplete}
                                            loading={context?.loadingBtn}
                                        >
                                            {t("Забронировать номер")}
                                        </Button>
                                    );
                                }}
                            </Form.Item>
                            <Typography
                                as="div"
                                className="text-center cancel"
                                size={14}
                                color="#000"
                            >
                                <Button type="text" onClick={onCancel}>
                                    {t("Отменить")}
                                </Button>
                            </Typography>
                        </Space>
                    </Form>
                </Typography>
            </div>
        );
    })
);

interface IProps {
    phone: number;
    type: number;
    filters?: IPhonesFiltersRequest;
    Service?: PhoneService;
}
